import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: e = 16, useVw: l, useRem: o, color: n, withColor: i, removeClassName: t, disableSSR: m, style: c, ...p }) => {
  const x = c ? { ...d, ...c } : d;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-monijiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-æ¨¡æäº¤æ"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: i ? r(n, 0, "#262933") : "#262933",
        datafollowfill: i ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M7.25 14.422a.9.9 0 0 1 .9-.9h1.997V11.48a.9.9 0 0 1 1.8 0v2.042h1.997a.9.9 0 0 1 0 1.8h-1.997v2.043a.9.9 0 1 1-1.8 0v-2.043H8.15a.9.9 0 0 1-.9-.9Zm14.957-2.053a1.655 1.655 0 1 1-3.31 0 1.655 1.655 0 0 1 3.31 0Zm3.24 3.601a1.655 1.655 0 1 1-3.31 0 1.655 1.655 0 0 1 3.31 0Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.454 5.59a5.172 5.172 0 0 0-5.157 4.777l-.898 11.704a4.328 4.328 0 0 0 6.9 3.804l1.447-1.078a9.777 9.777 0 0 1 5.836-1.933h1.238c2.133 0 4.21.677 5.934 1.933l1.584 1.154a4.06 4.06 0 0 0 6.444-3.525l-.723-11.975a5.172 5.172 0 0 0-5.163-4.86H7.454Zm17.442 1.8H7.454a3.372 3.372 0 0 0-3.363 3.115L3.194 22.21a2.528 2.528 0 0 0 4.03 2.221l1.448-1.077a11.578 11.578 0 0 1 6.91-2.289h1.238c2.514 0 4.963.798 6.994 2.279l1.584 1.154a2.26 2.26 0 0 0 3.587-1.963l-.723-11.974a3.372 3.372 0 0 0-3.366-3.17Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = h;
export {
  s as default
};
